import Customer from "models/Customer";
import Survey from "models/Survey";
import SurveyLocale from "models/SurveyLocale";

export const SET = "surveyDetail/SET";
export const SET_LOCALE = "surveyDetail/SET_LOCALE";
export const SET_SURVEY_STATUS = "surveyDetail/SET_SURVEY_STATUS";
export const INIT = "surveyDetail/INIT";
export const SET_ERRORS = "surveyDetail/SET_ERRORS";
export const SET_LOADING = "surveyDetail/SET_LOADING";
export const SET_ATTR_LOADING = "surveyDetail/SET_ATTR_LOADING";

// ActionCreator
export const setSurveyDetail = res => ({
  type: SET,
  customer: new Customer(res.customer),
  attrs: res.attrs,
  survey: new Survey(Object.assign({}, res.survey, { canViewReport: res.canViewReport })),
  surveyLocales: res.surveyLocales.map(sl => new SurveyLocale(sl)),
  customerLocales: res.locales.map(locale => locale.locale.key),
  alertDays: res.alertDays,
  isChecked: res.isChecked
});

export const setLocale = localeId => ({
  type: SET_LOCALE,
  localeId
});

export const setSurveyStatus = status => ({
  type: SET_SURVEY_STATUS,
  status
});

export const init = () => ({
  type: INIT
});

export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

export const setLoading = loading => ({
  type: SET_LOADING,
  loading
});

export const setAttributeLoading = attrLoading => ({
  type: SET_ATTR_LOADING,
  attrLoading
});

// Reducer
const initialState = {
  customer: new Customer(),
  survey: new Survey(),
  surveyLocales: [],
  selectedSurveyLocale: new SurveyLocale(),
  attrs: [],
  errors: [],
  loading: false,
  attrLoading: false,
  alertDays: '',
  isChecked: false
};

const surveyDetail = (state = initialState, action) => {
  switch (action.type) {
    case SET: {
      const { customer, survey, attrs, surveyLocales, customerLocales, alertDays, isChecked } = action;
      let validLocales = [];
      if (survey.isOpened()) {
        validLocales = surveyLocales;
      } else {
        surveyLocales.forEach(
          surveyLocale =>
            customerLocales.indexOf(surveyLocale.locale.key) > -1 &&
            validLocales.push(surveyLocale)
        );
      }
      const selectedSurveyLocale =
        validLocales.length > 0 ? validLocales[0] : 0;
      const errors = [];
      const loading = false;
      const attrLoading = false;
      if (selectedSurveyLocale === 0) {
        errors.push("アンケートの使用言語が選択されていません。");
      }

      return {
        ...state,
        customer,
        survey,
        surveyLocales: validLocales,
        selectedSurveyLocale,
        attrs,
        errors,
        loading,
        attrLoading,
        alertDays,
        isChecked
      };
    }

    case SET_LOCALE: {
      const { localeId } = action;
      const selectedSurveyLocale = state.surveyLocales.find(
        sl => sl.localeId === localeId
      );
      return { ...state, selectedSurveyLocale };
    }

    case SET_SURVEY_STATUS: {
      const survey = state.survey.set("status", action.status);
      return { ...state, survey };
    }

    case INIT: {
      return initialState;
    }

    case SET_ERRORS: {
      const { errors } = action;
      return { ...state, errors };
    }

    case SET_LOADING: {
      const { loading } = action;
      return { ...state, loading };
    }
    case SET_ATTR_LOADING: {
      const { attrLoading } = action;
      return { ...state, attrLoading };
    }

    default:
      return state;
  }
};

export default surveyDetail;



// WEBPACK FOOTER //
// ./src/redux/modules/surveyDetail.js